'use strict';

apiFactory.$inject = ["$resource", "$cacheFactory", "config"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.apiFactory = apiFactory;
/*@ngInject*/
function apiFactory($resource, $cacheFactory, config) {
    var baseUrl = config.webApiBaseUrl;

    //var sellersCache = $cacheFactory('sellers');
    // var categoriesCache = $cacheFactory('categories');

    return {
        // products

        products: $resource(baseUrl + 'products/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            query: {
                method: 'GET',
                isArray: true
            },
            save: {
                method: 'POST'
            },
            remove: {
                method: 'DELETE'
            },
            delete: {
                method: 'DELETE'
            }
        }),
        productMedipim: $resource(baseUrl + 'products/:productId/getMediPimData', null, {
            getMedipimData: {
                method: 'GET',
                isArray: false
            }
        }),
        productSearch: $resource(baseUrl + 'products/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),

        outletProductsSearch: $resource(baseUrl + 'products/searchOutletProducts', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalProducts: $resource(baseUrl + 'productrentals/:sellerId/getByCategory/:categoryId', null, {
            getAll: {
                method: 'GET',
                isArray: true
            }
        }),
        rentalProduct: $resource(baseUrl + 'productrentals/:productId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalProductMedipim: $resource(baseUrl + 'productrentals/:productId/getMediPimData', null, {
            getMedipimData: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalProductsOrder: $resource(baseUrl + 'rentalorder/rentProducts', null, {
            order: {
                method: 'POST',
                isArray: false
            }
        }),
        rentalProductCategories: $resource(baseUrl + 'productrentals/getRentalProductCategories/:sellerId', null, {
            getAll: {
                method: 'GET',
                isArray: true
            }
        }),
        rentalHistory: $resource(baseUrl + 'rentalHistory/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalHistoryDetail: $resource(baseUrl + 'rentalHistory/:id', null, {
            getById: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalHistoryRemark: $resource(baseUrl + 'rentalHistory/remark', null, {
            set: {
                method: 'PUT',
                isArray: false
            }
        }),
        rentalHistoryStatus: $resource(baseUrl + 'rentalHistoryStatus/search', null, {
            getAll: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalOrderSearch: $resource(baseUrl + 'rentalorder/search', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        productReservations: $resource(baseUrl + 'productreservations/getreservations?sortField=:sortField&sortAsc=:sortAsc', null, {
            getAll: {
                method: 'GET',
                isArray: true
            }
        }),
        // searchCities: $resource(baseUrl + 'belgiumPostalLocality?name=:name&code=:code ', null, {
        //     execute: {
        //         method: 'GET',
        //         isArray: false
        //     }
        // }),
        // searchStreet: $resource(baseUrl + 'belgiumStreet?name=:name&postalLocalityId=:postalLocalityId', null, {
        //     execute: {
        //         method: 'GET',
        //         isArray: false
        //     }
        // }),
        searchCities: $resource(baseUrl + 'postalLocality?name=:name&code=:code', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        searchStreet: $resource(baseUrl + 'street?name=:name&postalLocalityId=:postalLocalityId', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        productFilter: $resource(baseUrl + 'products/filter', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        productStock: $resource(baseUrl + 'products/stock/:productNumber/:quantity', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        productDiscounts: $resource(baseUrl + 'products/getProductDiscounts/:productId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        // sellers

        sellers: $resource(baseUrl + 'sellers/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        libraryQuestions: $resource(baseUrl + 'sellers/:sellerId/getQuestions', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        libraryDocumentCategories: $resource(baseUrl + 'sellers/:sellerId/getDocumentCategories', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        libraryDocument: $resource(baseUrl + 'sellers/DownloadFile/:documentId', null, {
            get: {
                method: 'GET',
                responseType: 'arraybuffer'
            }
        }),

        outletSeller: $resource(baseUrl + 'sellers/outlet', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        menuSellers: $resource(baseUrl + 'sellers/getSellersForMenu', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        sellerModules: $resource(baseUrl + 'sellers/:id/modules', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        sellerAbout: $resource(baseUrl + 'sellers/:id/about', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerBanners: $resource(baseUrl + 'sellers/:id/home/banners', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerProductsAndDiscounts: $resource(baseUrl + 'sellers/:id/home/productsdiscounts', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerCategory: $resource(baseUrl + 'sellers/:id/category/:categoryId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        totalPriceDiscounts: $resource(baseUrl + 'sellers/:id/totalPriceDiscounts', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        sellerContact: $resource(baseUrl + 'sellers/:id/contact', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerPublic: $resource(baseUrl + 'sellers/:id/public', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        //wholeSalers

        wholesalers: $resource(baseUrl + 'wholeSaler/getAllWholeSalers', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        // partnerships

        partnerships: $resource(baseUrl + 'partnership/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: false
            }
        }),

        // sellerCategory: $resource(baseUrl + 'sellers/:id/category/:categoryId', null, {
        //     get: { method:'GET', isArray: false }
        // }),

        // brands

        brands: $resource(baseUrl + 'brands/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // banner

        banners: $resource(baseUrl + 'banner', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // categories

        categories: $resource(baseUrl + 'categories', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'POST',
                isArray: true
            }
        }),

        categoriesMenu: $resource(baseUrl + 'categories/menu', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        sellerCategories: $resource(baseUrl + 'products/sellerCategories/:sellerId', null, {
            getSellerCategories: {
                method: 'GET',
                isArray: false
            }
        }),
        category: $resource(baseUrl + 'categories/get/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        // cart

        cart: $resource(baseUrl + 'shoppingcart/v2', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        //checkout cart
        checkoutCart: $resource(baseUrl + 'shoppingcart/v2/checkout', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        shoppingCartProducts: $resource(baseUrl + 'shoppingcart/getShoppingCartProducts', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        getCustomerAccounts: $resource(baseUrl + 'shoppingcart/customerAccounts', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setProductQuantity: $resource(baseUrl + 'shoppingcart/setProductQuantity', null, {
            execute: {
                method: 'POST',
                isArray: true
            }
        }),

        addProductToCart: $resource(baseUrl + 'shoppingcart/addProduct', null, {
            execute: {
                method: 'POST'
            }
        }),

        setQuantityOfProductToCart: $resource(baseUrl + 'shoppingcart/setQuantityOfProduct', null, {
            execute: {
                method: 'POST'
            }
        }),

        removeProductFromCart: $resource(baseUrl + 'shoppingcart/removeProduct/:productId/:discountId', null, {
            execute: {
                method: 'DELETE'
            }
        }),

        addPromoPackToCart: $resource(baseUrl + 'shoppingcart/addPromoPack', null, {
            execute: {
                method: 'POST'
            }
        }),

        setQuantityOfPromoPackToCart: $resource(baseUrl + 'shoppingcart/setQuantityOfPromoPack', null, {
            execute: {
                method: 'POST'
            }
        }),

        removePromoPackFromCart: $resource(baseUrl + 'shoppingcart/removePromoPack/:productId/:discountId', null, {
            execute: {
                method: 'DELETE'
            }
        }),

        setPanaceeToCart: $resource(baseUrl + 'shoppingcart/setPanacee', null, {
            execute: {
                method: 'POST'
            }
        }),

        removePanaceeFromCart: $resource(baseUrl + 'shoppingcart/removePanacee/:productId/:discountId', null, {
            execute: {
                method: 'DELETE'
            }
        }),

        getAddedToCartInfo: $resource(baseUrl + 'shoppingcart/addedToCartInfo/:id/:discountId', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        checkout: $resource(baseUrl + 'shoppingcart/checkout/v2', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),

        createOrders: $resource(baseUrl + 'shoppingcart/order', null, {
            execute: {
                method: 'POST',
                isArray: true
            }
        }),

        clearCart: $resource(baseUrl + 'shoppingcart/clear', null, {
            execute: {
                method: 'DELETE',
                isArray: false
            }
        }),

        deactivateCartMessage: $resource(baseUrl + 'shoppingcart/deactivateMessage/:messageId', {
            messageId: '@messageId'
        }, {
            deactivate: {
                method: 'PUT',
                isArray: false
            }
        }),

        reOrderProducts: $resource(baseUrl + 'shoppingcart/reOrderProducts', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),

        // order
        orders: $resource(baseUrl + 'orders/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        orderSearch: $resource(baseUrl + 'orders/search', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        shippingNoteSearch: $resource(baseUrl + 'orders/:id/shippingNote/:warehouseCode/:shippingNote', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        setOrderDeliveryDate: $resource(baseUrl + 'orders/setDeliveryDate', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),

        // discounttypes
        discounttypes: $resource(baseUrl + 'discounttypes/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        // tenants
        tenants: $resource(baseUrl + 'account/accounts', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // myAccount
        myAccount: $resource(baseUrl + 'account/myaccount', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        currentTenant: $resource(baseUrl + 'account/currentTenant', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setBuyerMail: $resource(baseUrl + 'account/setBuyerMail', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),

        setBuyerMailLanguage: $resource(baseUrl + 'account/setBuyerMailLanguage', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),
        // tenantsOld
        // tenants: $resource(baseUrl + 'tenants/:id', null, {
        //     get: { method:'GET', isArray: false },
        //     list: { method:'GET', isArray: true }
        // })

        //news
        newsSearch: $resource(baseUrl + 'news/search', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        news: $resource(baseUrl + 'news/:id', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        newsCategories: $resource(baseUrl + 'news/categories/search', null, {
            execute: {
                method: 'GET',
                isArray: true
            }
        }),

        // fast order
        searchProduct: $resource(baseUrl + 'shoppingcart/searchProduct', null, {
            execute: {
                method: 'GET',
                isArray: true
            }
        }),

        quickAddProducts: $resource(baseUrl + 'shoppingcart/quickAddProducts', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),
        removeSellerFromCart: $resource(baseUrl + 'shoppingcart/removeSellerFromCart', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),
        // contracts
        contracts: $resource(baseUrl + 'contract', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        numberOfContracts: $resource(baseUrl + 'contract/amount/:sellerId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        contractDetail: $resource(baseUrl + 'contract/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerContract: $resource(baseUrl + 'sellers/:sellerId/contract/:contractId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerContracts: $resource(baseUrl + 'sellers/:sellerId/contract', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // vaccines
        vaccinreservation: $resource(baseUrl + 'vaccinreservation', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setReservationAmounts: $resource(baseUrl + 'vaccinreservation/setReservationAmounts', null, {
            set: {
                method: 'PUT',
                isArray: true
            }
        }),

        // reservation campaigns
        reservationCampaign: $resource(baseUrl + 'reservation/:code', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setReservationCampaignAmounts: $resource(baseUrl + 'reservation/:code/setReservationAmounts', null, {
            set: {
                method: 'PUT',
                isArray: true
            }
        }),

        getActiveReservationCampaigns: $resource(baseUrl + 'reservation/activeCampaigns', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        //corona
        coronaReservation: $resource(baseUrl + 'reservation', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        //outlet
        outlet: $resource(baseUrl + 'outlet', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        outletHomePage: $resource(baseUrl + 'outlet/outletHomePage', null, {
            get: {
                method: 'GET'
            }
        }),

        //buyer-base
        buyerBaseSearch: $resource(baseUrl + 'buyerBase?search=:search&sellerId=:sellerId', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        certificates: $resource(baseUrl + 'certificates/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        podValidateContact: $resource(baseUrl + 'pod/validateContact?licenseNumber=:licenseNumber', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        podOrderTypes: $resource(baseUrl + 'pod/orderTypes', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        podPackageTypes: $resource(baseUrl + 'pod/packageTypes', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        podOrderAdd: $resource(baseUrl + 'pod/:orderTypeId', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),
        podOrderDetail: $resource(baseUrl + 'pod/:orderTypeId/cancel', null, {
            cancel: {
                method: 'POST',
                isArray: false
            }
        }),
        pod: $resource(baseUrl + 'pod/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        podSearch: $resource(baseUrl + 'pod/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        podLineStateHistory: $resource(baseUrl + 'pod/:lineId/stateHistory', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        })
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/core/apiService.js
// module id = 699
// module chunks = 0